import React from 'react'
import PropTypes, { object } from 'prop-types'
import _ from 'lodash'

import NextSectionButtons from 'Components/Tickets/Form/Sections/NextSectionButtons'

const TicketCreateFormSectionsTicketType = ({
  hidden,
  ticket_type_id,
  setNextModalSection,
  setFieldValue,
  ticketTypes,
  serviceCategories,
  setFieldErrorClasses
}) => {
  if (hidden) {
    return null
  }

  const TicketType = ({ type }) => (
    <div className="flex--grow" style={{ width: '500px' }}>
      <label htmlFor={`ticket_ticket_type_${type.id}`} className="label label--half-margin mb-4">
        <input
          type="radio"
          onChange={(event) => { event.target.checked && setTicketType(type) }}
          checked={ticket_type_id === type.id}
          className={setFieldErrorClasses(type)}
          id={`ticket_ticket_type_${type.id}`}
        />
        <span />
        {type.name}
        <p className="label__description">
          {type.description}
        </p>
      </label>
    </div>
  )

  TicketType.propTypes = { type: PropTypes.shape.isRequired }

  const setTicketType = (type) => {
    if (type.name === 'User Management') {
      setFieldValue('ticket_type_id', type.id)
      setFieldValue(
        'service_category_id',
        _.find(serviceCategories, ['name', 'User Management']).id
      )
    }

    setFieldValue('ticket_type_id', type.id)
  }

  const clonedTicketTypes = _.clone(ticketTypes)
  const sortedTicketTypes = _.each(clonedTicketTypes, (element, index) => {
    if (element.name === 'User Management') {
      _.remove(clonedTicketTypes, ['name', 'User Management'])
      clonedTicketTypes.splice(1, 0, element)
    }
  })

  return (
    <div>
      <label>
        Please select your ticket type
      </label>
      <br />

      <div className="flex flex--wrap">
        {_.map(sortedTicketTypes, type => <TicketType key={type.id} type={type} />)}
      </div>

      <NextSectionButtons setNextModalSection={setNextModalSection} />
    </div>
  )
}

TicketCreateFormSectionsTicketType.propTypes = {
  hidden: PropTypes.bool,
  ticket_type_id: PropTypes.number,
  setFieldValue: PropTypes.func.isRequired,
  setFieldErrorClasses: PropTypes.func.isRequired,
  ticketTypes: PropTypes.arrayOf(object).isRequired,
  setNextModalSection: PropTypes.func.isRequired
}

TicketCreateFormSectionsTicketType.defaultProps = {
  hidden: false
}

export default TicketCreateFormSectionsTicketType
